module.exports = __webpack_public_path__ + "img/gauge.15caf37d.svg";